
import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { useSearchParams } from "react-router-dom";
// HELPERS
import useWindowDimensions from "../helpers/useWindowDimensions";
// REDUX ACTIONS
import { setAlert } from "../redux/actions/alerts";
import {
    getAllArticlesPaginatedByType,
    getAllArticlesCountByType,
    getSearcArticlesPaginatedByType,
    getSearchArticlesCountByType,
    getArticleManufacturers,
    selectArticle,    
    getArticle,
} from "../redux/actions/articles";
// COMPONENTS
import ListPageFilterDropdown from "../components/Shared/ListPageFilterDropdown";
import ListPageTable from "../components/Shared/ListPageTable";
import OptionsDialog from "../components/ArticleForms/OptionsDialog";
import BackArrow from "../components/Shared/BackArrow";
import ListPageHeader from "../components/Shared/ListPageHeader";
// CSS STYLES
import styles from "../styles/pages/OtherArticlesListPage.module.css";
// ICONS
import { MdOutlineAdd } from "react-icons/md";



const otherArticlesListTableKey = [
    {
        label:'Title',
        gridFr: 4,
        dataKey: 'otherArticlesListTable-name',
        dataSource: 'otherArticles-list',
    },
    {
        label:'Author',
        gridFr: 3,
        dataKey: 'otherArticlesListTable-author',
        dataIsLink: false,
        dataSource: 'otherArticles-list',
    },
    {
        label:'Manufacturer',
        gridFr: 2,
        dataKey: 'otherArticlesListTable-manufacturer',
        dataIsLink: false,
        dataSource: 'otherArticles-list',
    },
    {
        label:'Post Date',
        gridFr: 1,
        dataKey: 'otherArticlesListTable-postDate',
        dataIsLink: false,
        dataSource: 'otherArticles-list',
    },
    {
        label:'Published',
        gridFr: 1,
        dataKey: 'otherArticlesListTable-published',
        dataIsLink: false,
        dataSource: 'otherArticles-list',
    },
]

const otherArticlesListTableKey2 = [
    {
        label:'Title',
        gridFr: 3,
        dataKey: 'otherArticlesListTable-name',
        dataSource: 'otherArticles-list',
    },
    {
        label:'Author',
        gridFr: 3,
        dataKey: 'otherArticlesListTable-author',
        dataIsLink: false,
        dataSource: 'otherArticles-list',
    },
    {
        label:'Manufacturer',
        gridFr: 2,
        dataKey: 'otherArticlesListTable-manufacturer',
        dataIsLink: false,
        dataSource: 'otherArticles-list',
    },
    {
        label:'Post Date',
        gridFr: 1,
        dataKey: 'otherArticlesListTable-postDate',
        dataIsLink: false,
        dataSource: 'otherArticles-list',
    },
]

const otherArticlesListTableKey3 = [
    {
        label:'Title',
        gridFr: 3,
        dataKey: 'otherArticlesListTable-name',
        dataSource: 'otherArticles-list',
    },
    {
        label:'Author',
        gridFr: 3,
        dataKey: 'otherArticlesListTable-author',
        dataIsLink: false,
        dataSource: 'otherArticles-list',
    },
    {
        label:'Manufacturer',
        gridFr: 2,
        dataKey: 'otherArticlesListTable-manufacturer',
        dataIsLink: false,
        dataSource: 'otherArticles-list',
    },
    {
        label:'Post Date',
        gridFr: 1,
        dataKey: 'otherArticlesListTable-postDate',
        dataIsLink: false,
        dataSource: 'otherArticles-list',
    },
]

const otherArticlesListTableKey4 = [
    {
        label:'Title',
        gridFr: 3,
        dataKey: 'otherArticlesListTable-name',
        dataSource: 'otherArticles-list',
    },
    // {
    //     label:'Author',
    //     gridFr: 2,
    //     dataKey: 'otherArticlesListTable-author',
    //     dataIsLink: false,
    //     dataSource: 'otherArticles-list',
    // },
    {
        label:'Manufacturer',
        gridFr: 2,
        dataKey: 'otherArticlesListTable-manufacturer',
        dataIsLink: false,
        dataSource: 'otherArticles-list',
    },
]





const OtherArticlesListPage = ({
    // Redux Actions
    setAlert,
    getAllArticlesPaginatedByType,
    getAllArticlesCountByType,
    getSearcArticlesPaginatedByType,
    getSearchArticlesCountByType,
    getArticleManufacturers,
    selectArticle,
    getArticle,
    // Redux States
    article: {
        article,
        isLoadingArticleList,
        articlesPaginatesbyType,
        allArticlesCountByType,
        searchArticlesPaginatedByType,
        searchArticlesCountByType,
        articleManufacturersForFilter,
    }
}) => {
    const [searchParams, setSearchParams] = useSearchParams()
    const searchInputRef = useRef(null);
    const { width } = useWindowDimensions();

    const [searchTerm, setSearchTerm] = useState('');
    const [paginationPage, setPaginationPage] = useState(1)
    const [ceToRender, setCEToRender] = useState([])
    const [countToRender, setCountToRender] = useState(0)
    const [newestFilter, setNewestFilter] = useState('newest') 
    const [manufacturersFilterOptions, setManufacturersFilterOptions] = useState([])
    const [manufacturerFilter, setManufacturerFilter] = useState('all-manufacturers')
    const [selectedAction, setSelectedAction] = useState('');
    const [dialogOpen, setDialogOpen] = useState(false);


    const newestFilterOptions = [
        {name: 'Newest', value: 'newest'},
        {name: 'Oldest', value: 'oldest'},
    ]

    const pageSize = 10

    const handleEditOptions = (article, action) => {
        selectArticle(article)
        setSelectedAction(action)
        setDialogOpen(true)
    }

    // FETCH ARTICLE FROM ARTICLE ID FROM CMS SEARCH
    const handleEditFromSearch = (articleId) => {
        getArticle(articleId);
    }

    // IF CMS SEARCH RESULTS IN ARTICLE BY ID THAT MATCHES THEN OPEN EDIT MODAL
    useEffect(() => {
        const edit = searchParams?.get('edit')

        if (edit && article && +edit === article.article_id) {
            handleEditOptions(article, 'edit')
            const params = new URLSearchParams()
            setSearchParams(params, { replace: true })
        }
    }, [searchParams, article])

    useEffect(() => {
        const add = searchParams?.get('add')
        const edit = searchParams?.get('edit')

        if (add === 'true') {
            handleEditOptions(null, 'add')
            const params = new URLSearchParams()
            setSearchParams(params, { replace: true })
        } else if (edit) {
            handleEditFromSearch(+edit)
        }
    }, [searchParams])

    useEffect(() => {
        getAllArticlesPaginatedByType(0, 'other-articles', newestFilter, manufacturerFilter, pageSize)
        getAllArticlesCountByType('other-articles', manufacturerFilter)
        getArticleManufacturers('other-articles')
    }, [getAllArticlesPaginatedByType])


    useEffect(() => {
        if (!searchTerm) {
            setCEToRender(articlesPaginatesbyType)
            setCountToRender(allArticlesCountByType)
        } else {
            setCEToRender(searchArticlesPaginatedByType)
            setCountToRender(searchArticlesCountByType)
        }
    }, [articlesPaginatesbyType, allArticlesCountByType, searchArticlesPaginatedByType, searchArticlesCountByType ])

    useEffect(() => {
                if (articleManufacturersForFilter.length > 0 ) {
                    formatManufacturersFilterOptions(articleManufacturersForFilter)
                }
            }, [articleManufacturersForFilter])
        
        const formatManufacturersFilterOptions = (manufacturers) => {
            
            const formattedOptions = manufacturers.map((manu) => {
                return manu && {
                    name: manu.name,
                    value: manu.manufacturer_id
                }
            })
            setManufacturersFilterOptions(formattedOptions)
        }


    


    const handleNewestFilter = (orderSelected) => {
        if (!searchTerm) {
            setNewestFilter(orderSelected)
            setPaginationPage(1)
            getAllArticlesPaginatedByType(0, 'other-articles', orderSelected, manufacturerFilter, pageSize)
            getAllArticlesCountByType()
        } else {
            setNewestFilter(orderSelected)
            setPaginationPage(1)
            getSearcArticlesPaginatedByType(0, 'other-articles', searchTerm, orderSelected, manufacturerFilter, pageSize)
            getSearchArticlesCountByType('other-articles',  searchTerm, orderSelected)
        }
        
    }

    const handleManufacturerFilter = (value) => {
        if (!searchTerm) {
            setManufacturerFilter(value)
            setPaginationPage(1)
            getAllArticlesPaginatedByType(0, 'other-articles', newestFilter, value, pageSize)
            getAllArticlesCountByType( 'other-articles', value )
        } else {
            setManufacturerFilter(value)
            setPaginationPage(1)
            getSearcArticlesPaginatedByType(0, 'other-articles', searchTerm, newestFilter, value, pageSize)
            getSearchArticlesCountByType( 'other-articles', searchTerm, value)
        }
        
}

    

    const handleClearFilters = () => {
        if (searchInputRef.current) {
            searchInputRef.current.value = ""; // Clear the input value
        }
        setSearchTerm('')
        setNewestFilter('newest')
        setPaginationPage(1)
        setManufacturerFilter('all-manufacturers')
        getAllArticlesPaginatedByType(0, 'other-articles', 'newest', 'all-manufacturers', pageSize)
        getAllArticlesCountByType('other-articles', 'all-manufacturers')
    }


    const handleDialogClose = () => {
        selectArticle(null)
        setSelectedAction('')
        setDialogOpen(false)
    }

    const editOption = {
        label:'Edit',
        gridFr: 1,
        dataKey: null,
        dataIsLink: false,
        dataSource: 'otherArticles-list',
        editCallback: (article) => handleEditOptions(article, 'edit'),
        deleteCallback: (article) => handleEditOptions(article, 'delete')
    }


    const handleSearch = (value) => {
        setPaginationPage(1)
        getData(0, 'other-articles', newestFilter, manufacturerFilter, value, pageSize)
    }

    const handlePagination = (page) => {
        getData(page,'other-articles', newestFilter, manufacturerFilter, searchTerm, pageSize)
    }

    const getData = (fetchPage, articleType, newestFilter, manufacturerFilter, searchTerm, pageSize) => {
        if (!searchTerm) {
            getAllArticlesPaginatedByType(fetchPage, articleType, newestFilter, manufacturerFilter, pageSize)
            getAllArticlesCountByType(articleType, manufacturerFilter)
        } else if (searchTerm)  {
            getSearcArticlesPaginatedByType(fetchPage, articleType, searchTerm, newestFilter, manufacturerFilter, pageSize)
            getSearchArticlesCountByType(articleType, searchTerm, manufacturerFilter)
        }
    }

    return (
        <div className={styles.othersListPage_main_container}>

            <BackArrow link={'/onsite-content'} linkText={'Return to Manage Content List'}/>

            {/* HEADER */}
            <ListPageHeader 
                title={'Other Articles Management'}
                description={'Browse and manage all other articles for Dental Product Shopper.  This page lets you search, add, edit, or remove other articles.'}
                unpublishedNote={'indicates Article is unpublished'}
                addButtonProps={{
                    text: 'Add Other Articles',
                    icon: <MdOutlineAdd size={20} color={'white'}/>,
                    onClick: () => handleEditOptions(null, 'add')
                }}
                searchProps={{
                    placeholder: 'Search Other Articles by Title',
                    searchFunction: (value) => handleSearch(value),
                    getContent: () => handleSearch(),
                    searchTerm,
                    setSearchTerm
                }}
                exportProps={{
                    text: 'Export Data',
                    onClickExports: () => handleEditOptions(null, 'export-other-articles')
                }}
                
            /> 


            {/* FILTER BUTTONS ROW */}
            <section className={styles.search_filters_section_container}>
                {/* TITLE */}
                <p className={styles.search_filters_title}>Search Filters</p>
                {/* FILTERS ROW */}
                <div className={styles.search_filters_main_row}>
                    {/* NEWEST FILTER */}
                    <ListPageFilterDropdown
                        title={'Newest'}
                        options={newestFilterOptions}
                        selectedOption={newestFilter}
                        starterOption={'newest'}
                        changeFilter={handleNewestFilter}
                        isDisabled={false}
                        greenOnChange={newestFilter !== 'newest'}
                    />
                    {/* MANUFACTURER FILTER */}
                    <ListPageFilterDropdown
                        title={'Manufacturer'}
                        options={manufacturersFilterOptions}
                        selectedOption={manufacturerFilter}
                        changeFilter={handleManufacturerFilter}
                        isDisabled={false}
                        greenOnChange={manufacturerFilter !== 'all-manufacturers'}
                    />
                    {/* CLEAR FILTER */}
                    
                    {(newestFilter !== 'newest' || manufacturerFilter !== 'all-manufacturers') ? 
                        <ListPageFilterDropdown
                            isClearFilterBtn={true}
                            handleClearFilters={handleClearFilters}
                        /> 
                    : null}
                </div>
                
            </section>   


            {/* MAIN TABLE */}
            <ListPageTable
                tableTitle={'Other Articles List'}
                tableKeyObjects={[
                    ...width > 1450 ? otherArticlesListTableKey : width > 1350 ? otherArticlesListTableKey2 : width > 1150 ? otherArticlesListTableKey3 :  otherArticlesListTableKey4,
                    editOption
                ]}
                tableData={ceToRender}
                isLoading={isLoadingArticleList}
                paginateProps={{
                    paginationPage,
                    setPaginationPage,
                    pageSize: pageSize,
                    count: countToRender,
                    getContent: (page) => handlePagination(page)
                }}
            />
            

            <OptionsDialog
                selectedAction={selectedAction}
                open={dialogOpen}
                handleClose={handleDialogClose}
                page={paginationPage - 1}
                searchTerm={searchTerm}
                newestFilter={newestFilter}
                manufacturerFilter={manufacturerFilter}
                type={'other'}
                pageArticleType={'other-articles'}
            />
        </div>
    );
};

const mapStateToProps = (state) => ({
    article: state.article,
});

export default connect(mapStateToProps, {
    setAlert,
    getAllArticlesPaginatedByType,
    getAllArticlesCountByType,
    getSearcArticlesPaginatedByType,
    getSearchArticlesCountByType,
    getArticleManufacturers,
    selectArticle,
    getArticle,
})(OtherArticlesListPage);
